import React, { useState, useEffect } from "react";
import { Form, Input, Select, InputNumber } from "antd";
import { ReactComponent as DownIcon } from "../../../assets/svgs/dropdown_icon.svg";
import { LinkExpireUnits } from "../../../utils/constant";
import Button from "../../atoms/Button";

const LinkExpiryTime = ({
  name,
  unit,
  user_origin = null,
  value,
  no,
  onSave,
}) => {
  const UserType = ({ name, type = null }) => {
    return (
      <div>
        {name}{" "}
        {type != null && (
          <span
            className={`text-[10px] font-bold ${
              type == "NAT" ? "text-green-500 " : "text-blue-500"
            } `}
          >
            {type}
          </span>
        )}
      </div>
    );
  };

  const [selectedTimeUnit, setSelectedTimeUnit] = useState(unit || "");
  const [inputValue, setInputValue] = useState(value || "");


  useEffect(() => {
    setSelectedTimeUnit(unit || "");
    setInputValue(value || "");
  }, [unit, value]);

  const handleSelectChange = (value) => {
    setSelectedTimeUnit(value);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleSave = () => {
    if (onSave) {
      onSave(selectedTimeUnit, inputValue);
    }
  };

  return (
    <div>
      <div
        className={`${
          no % 2 != 0 ? "bg-white" : "bg-blue-100"
        } px-10 py-2 flex justify-between  `}
      >
        <div className="text-sm  w-1/6 flex  justify-between items-center ">
          <UserType name={name} type={user_origin} />
        </div>
        <div className="flex w-1/5 justify-between">
          <Select
            showSearch
            className="primary_variant"
            optionFilterProp="label"
            suffixIcon={
              <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
            }
            placeholder={"Time Units"}
            options={LinkExpireUnits}
            value={selectedTimeUnit}
            onChange={handleSelectChange}
          />
          <Input
            className="border-0 border-b-2 rounded-none ml-4"
            value={inputValue}
            onChange={handleInputChange}
            inputMode="numeric"
          />
        </div>
      </div>
      <div className=" text-end mx-10 mt-6">
        <Button
          varient={"primary"}
          color={"blue"}
          className={"text-white px-6 py-2 "}
          onClick={handleSave}
        >
          Save Changes
        </Button>
      </div>
    </div>
  );
};

export default LinkExpiryTime;
